// extracted by mini-css-extract-plugin
export default {"burgerBtn":"BurgerBtn_burgerBtn__byZEu","iconBurger":"BurgerBtn_iconBurger__i5BAb"};